"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchModalRemoveButton = exports.SearchInputBox = exports.SearchButton = exports.SearchModalDiv = exports.SearchBgDiv = exports.RecoilUsedDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const imageUrl_1 = require("../../../resource/imageUrl");
exports.RecoilUsedDiv = styled_components_1.default.div `
  position: relative;

  box-sizing: border-box;

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto 18px 22px;
  gap: 20px;
  align-items: center;

  width: 100%;
  max-width: ${(props) => props.input_width};
  min-width: 430px;
  height: 42px;
  padding-right: 20px;

  border-radius: ${(props) => props.focus ? "21px 21px  0 0" : "21px"};

  box-shadow: ${(props) => props.focus ? "0 2px 8px 0 rgba(0, 0, 0, 0.2)" : ""};

  background-color: #f5f5f5;
`;
exports.SearchBgDiv = styled_components_1.default.div `
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
`;
exports.SearchModalDiv = styled_components_1.default.div `
  position: absolute;
  z-index: 1010;
  top: 42px;
  left: 0;

  /* display: flex; */

  width: 100%;
  max-height: 602px;

  overflow-x: hidden;
  overflow-y: auto;

  border-top: 1px solid #e5e5e5;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;

  background-color: #fff;

  box-shadow: ${(props) => props.focus ? "0 7px 8px 2px rgba(0, 0, 0, 0.2)" : ""};

  .Search__Modal__ScrollWrap {
    position: relative;
    left: ${(props) => {
    if (props.isRecent === true) {
        return "-4px";
    }
    if (props.isNeedScroll === true) {
        return "-4px";
    }
    return "0";
}};

    overflow-x: hidden;
    overflow-y: ${(props) => {
    if (props.isRecent === true) {
        return "hidden";
    }
    if (props.isNeedScroll === true) {
        return "scroll";
    }
    return "hidden";
}};

    width: 100%;
    max-height: 602px;

    transition: none;
  }

  .Search__Modal {
    position: relative;
    left: ${(props) => {
    if (props.isRecent === true) {
        return "4px";
    }
    if (props.isNeedScroll === true) {
        return "4px";
    }
    return "0";
}};

    overflow-y: auto;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    width: 100%;
    max-width: ${document.body.querySelector(".Input__Wrap")
    ?.clientWidth}px;

    transition: none;

    button.query {
      display: flex;
      /* align-items: center; */
      /* height: 42px; */
      font-size: 0.9375rem;
      letter-spacing: -0.0469rem;
      img {
        width: 18px;
        height: 18px;
      }
      .recent_remove {
        padding: 6px 6px 4.25px 6px;
      }
    }

    button.query:hover {
      background-color: #eaeaea;

      .Vertical__Focus {
        background-color: #0ac7ce;
      }
    }

    .locSearch {
      font-weight: 500;
      letter-spacing: -0.75px;
      color: #202020;
    }
  }

  /* .Focus__Wrap {
    position: absolute;
    right: 0;

    overflow-y: hidden;

    width: 10px;
    height: 100%;

    padding-top: 12px;
  }

  .Search__Focus__High {
    position: relative;
    z-index: -1;

    width: 10px;
    height: 58px;

    background-color: #0ac7ce;
  } */
`;
exports.SearchButton = styled_components_1.default.button `
  /* position: absolute; */
  /* right: 20px; */

  width: 22px;
  height: 22px;

  background-image: url(${imageUrl_1.search_input.search_img});
  background-size: 100%;
`;
exports.SearchInputBox = styled_components_1.default.input `
  display: block;
  max-width: 95%;

  width: 100%;
  height: 30px;

  margin-left: 24px;
  padding: 0 0 2px 0;

  background-color: transparent;
  outline: transparent;
  border: transparent;

  font-size: 0.9375rem;
  line-height: 1.3125rem;
  letter-spacing: -0.0469rem;
  color: #202020;

  &::placeholder {
    height: 21px;

    font-size: 0.9375rem;
    letter-spacing: -0.0469rem;
    color: #9e9e9e;
  }
`;
exports.SearchModalRemoveButton = styled_components_1.default.button `
  /* position: absolute; */
  /* right: 62px; */

  display: flex;
  align-items: center;

  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
  }
`;
